import { SignInPage as DefaultSignInPage } from '@backstage/core-components';
import {
  SignInPageProps,
  useApi,
  configApiRef,
  oktaAuthApiRef,
} from '@backstage/core-plugin-api';

import { IconDevops } from '@fastly/beacon-icons/illustrations';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '& header': {
      display: 'none',
    },
  },
  header: {
    margin: '72px 0 24px -8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .beacon-icon': {
        width: '42px',
    }
  },
  heading: {
    marginTop: '18px',
    marginLeft: '12px',
  }
});

export const SignInPage: React.FC<SignInPageProps> = props => {
  const classes = useStyles();

  const config = useApi(configApiRef);
  const authEnvironment = config.getOptionalString('auth.environment');
  const title = config.getString('app.title');

  const header = (
    <Box className={classes.header}>
        <IconDevops />
        <h2 className={classes.heading}>{title}</h2>
    </Box>
  )

  if (authEnvironment !== 'local') {
    return (
      <Box className={classes.root}>
        <DefaultSignInPage
          {...props}
          auto
          align="center"
          titleComponent={header}
          providers={[{
            id: 'okta',
            title: 'Sign In',
            message: 'Sign in using Okta',
            apiRef: oktaAuthApiRef,
          }]}
        />
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <DefaultSignInPage
        {...props}
        align="center"
        titleComponent={header}
        auto
        providers={['guest']}
      />
    </Box>
  );
};
